import { combineReducers } from "redux";
import job from "./jobInfo";
import ship from "./shipInfo";

export default combineReducers({
  job,
  ship
});
